
<section class="deliverables-section">
  <div class="top-toolbar">
    <button auto="strat-map-btn" [class]="isStrategyMayActiveClass" (click)="onClickStrategyMap()">Strategy Map</button>
    <button auto="annual-plan-btn" [class]="isAnnualPlanActiveClass" (click)="onClickAnnualPlan()">Annual Improvement Plan</button>
    <button auto="implementation-plan-btn" [class]="isImplementationPlanActiveClass" (click)="onClickImplementationPlan()">Annual Implementation Plan</button>
    <button auto="theory-action-btn" [class]="isTheoryOfActionActiveClass" (click)="onClickTheoryOfAction()">Theory of Action</button>
    <div class="top-toolbar-context-items">
      <p-menubar #contextMenu class="toolbar" [model]="menuItems"></p-menubar>
    </div>
  </div>
  <app-strategy-map
    *ngIf="isStrategyMayActive()"
    [strategyId]="strategyId"
    [permissions]="permissions"
    [purposeMissionBeliefs]="purposeMissionBeliefs"
    [headings]="headings"
    (headingsEdit)="onHeadingsEdit($event)"
    (headingsError)="onHeadingsError($event)"
    (planCoordinateChange)="onPlanCoordinateChange($event)">
  </app-strategy-map>
  <app-annual-plan
    *ngIf="isAnnualPlanActive()"
    [strategyId]="strategyId"
    [permissions]="permissions"
    [headings]="headings"
    (requestAnnualPlanPriorities)="onRequestAnnualPlanPriorities($event)"
    (planCoordinateChange)="onPlanCoordinateChange($event)">
  </app-annual-plan>
  <app-implementation-plan
    *ngIf="isImplementationPlanActive()"
    [strategyId]="strategyId"
    [permissions]="permissions"
    [selectedInitiative]="implementationPlanInitiative"
    (requestInitiatives)="onRequestInitiatives($event)"
    [headings]="headings"
    (requestInitiativeDetails)="onRequestInitiativeDetails($event)"
    (planCoordinateChange)="onPlanCoordinateChange($event)">
  </app-implementation-plan>
  <app-theory-of-action
    *ngIf="isTheoryOfActionActive()"
    [strategyId]="strategyId"
    [permissions]="permissions"
    [selectedInitiative]="theoryOfActionSelectedInitiative"
    [priorities]="theoryOfActionPrioritiesWithInitiatives"
    [hasInitiatives]="hasInitiatives"
    [headings]="headings"
    (requestInitiatives)="onRequestTheoryOfActionInitiatives()"
    (requestInitiativeDetails)="onRequestTheoryOfActionInitiativeDetails($event)"
    (planCoordinateChange)="onPlanCoordinateChange($event)">
  </app-theory-of-action>
</section>

<p-sidebar #editHeadingsSidebar
           [(visible)]="isEditHeadingsActive"
           appendTo="body"
           position="right"
           styleClass="priorities-sidebar"
           (onShow)="priorityHeadings.onShowSidebar(editHeadingsSidebar)"
           (onHide)="priorityHeadings.onHideSidebar()">
  <app-priority-headings #priorityHeadings
                         (edit)="onHeadingsEdit($event)"
                         (editError)="onHeadingsError($event)"
                         (cancel)="isEditHeadingsActive = false">
  </app-priority-headings>
</p-sidebar>

<p-dialog #downloadDialog styleClass="no-animation-dialog strategies-download-dialog" width="700" appendTo="body"
          [responsive]="true" [showHeader]="false" [modal]="true" [closable]="false" [positionTop]="20">
  <app-strategy-map-download (close)="downloadDialog.visible = false"></app-strategy-map-download>
</p-dialog>
